import React from 'react'
import '../App.css';
import { useState,useEffect} from 'react';
import axios from 'axios';
import book from '../icon/icons8-book-80.png';
import Promote1 from '../Image/Promote1.png';
import Promote2 from '../Image/Promote2.png'; 
import calendar from '../icon/icons8-calendar-96.png';
import deleteItem from '../icon/icons8-delete-100.png';
import mark from '../icon/icons8-exclamation-mark-96.png';
import { useLocation } from 'react-router-dom';
import {toast} from "react-toastify";



function MyBooking() {

    const location = useLocation();
    const {state} = location;
   
    const [phoneNumber,setPhoneNumber] = useState(state?.phone);
     const [data,setData] = useState([]);
    

    let counter =1;

    //useEffect
    useEffect(()=>{
        if(phoneNumber !=''){
            connectPhp();
        }    
    },[]);
    
    
    function connectPhp(){
        let data = [];
        const url="https://pta-hk.com/getMyBooking.php";
        let fData =new FormData();
        fData.append('phoneNum',phoneNumber);
        
        axios.post(url,fData).then
        (response=>
            {
                // Ensure we always have an array
                if (Array.isArray(response.data)) {
                    setData(response.data);
                } else {
                    console.log("Response data is not an array:", response.data);
                    setData([]); // Set to empty array if not array
                }
               
        }).catch((e)=>console.log(e));
      
    }

    //Handle phone change
    const handlePhoneChange=(e)=>{
        const value =e.target.value;
        setPhoneNumber(value);
    };

    //delete booking
    function deleteBooking(targetEventId,phoneNumber){
        let data;
        const url="https://pta-hk.com/deleteMyBooking.php";
        let fData =new FormData();
        fData.append('phoneNum',phoneNumber);
        fData.append('eventId',targetEventId)
        axios.post(url,fData).then
        (response=>{
            data = response.data;
            toast.error("已取消預約..",{
                position:"top-center",
            }); 
            console.log("Result Data",data);

             // Refresh the data by calling connectPhp again
            connectPhp();
        }).catch((e)=>console.log(e));

    };

    const handleSubmit = (e)=>{
        e.preventDefault();    
        const cleanedPhoneNum = phoneNumber.replace(/[^\d]/g, '').slice(0, 8);
        //check the start of number
        //^ start of number
        //[23569] -First digit must be 
        //d{7} -followed by 7 digit
        const valid = /^[23569]\d{7}$/.test(cleanedPhoneNum);
        console.log("Valid PhoneNum", valid);
        
        //valid phone number checked
        if (valid) {
            console.log('valid phone submitted !');
            connectPhp();
            setPhoneNumber('');
        }else{
            toast.error("請輸入有效電話號碼..",{
                position:"top-center",
            });      
            console.log('Please enter a valid telephone number ');
        }
     
    };

     
  return (
     <div className="container">
        <div className="banner-section">
            <img src={ Promote2 }
                alt="Poker Tournament Association"
                className="bannerImage2"
            />
        </div>

        <div className="container-content">
            <div className="registry-content">
                <div className="title">我的預約 &nbsp;&nbsp;
                    <img src={book}
                      alt="Poker Tournament Association"
                      className="icon"
                    />
                </div>
                <form onSubmit = {handleSubmit} className="booking-form">
                    <div className="booking-form-group">
                         <div className="form-notice">
                            *必須墳寫
                        </div>
                    </div>
                           {/********** Phone Input *****/}
                    <div className="booking-form-group">
                        <label span id="formInputLabel">聯絡電話*:</label>&nbsp;&nbsp;
                        <input className="form-input"
                            required
                            type="text"
                            maxLength={9}
                            id="phone"
                            value={phoneNumber}
                            onChange={handlePhoneChange}
                            style={{
                                padding:'8px',
                                border:`1px solid #ccc`,
                                borderRadius:'4px',
                                width:'100px',
                                backgroundColor:"#e0e0e0" 
                            }}
                        />
                    </div>

                    {/***** Button  ************/}       
                    <div className="form-group" style={{marginBottom:'20px',fontSize:'0.9rem'}}>
                        <button type="submit"
                            style={{
                              backgroundColor:'#F01010',
                              color:'#ffffff',
                              padding:'8px 15px',
                              border:'none',
                              borderRadius:'4px',
                              cursor:'pointer',
                              width:'250px',
                              
                            }}
                        >  
                        確認                
                        </button>
                    </div>  
                </form>          
              
            
              {/*** Show Point Result */}            
              { data.length > 0  ?
                <div className="table-container">
                            <div className="title">已預約比賽 &nbsp;&nbsp;
                                <img src={ calendar }
                                    alt="Poker Tournament Association"
                                    className="icon"
                                />

                            </div>
                            <table className="data-table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>編號</th>
                                        <th>日期</th>
                                        <th>時間</th>
                                        <th>名稱</th>
                                        <th>入場費</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item)=>(
                                        <tr key={item.id}>
                                            <td>{counter++}</td>
                                            <td>{item.EventId}</td>
                                            <td>{item.StartDate}</td>
                                            <td>{item.StartTime}</td>
                                            <td>{item.EventGame}</td>
                                            <td>{item.Fee}</td>
                                            {/*
                                            <td><img src={deleteItem}
                                                    alt="Poker Tournament Association"
                                                    className="icon"
                                                    onClick={() => {
                                                        console.log("EventId:", item.EventId);
                                                        console.log("Phone:", item.PhoneNum);
                                                        deleteBooking(item.EventId, item.PhoneNum)}}
                                                    />
                                            </td>
                                            */}
                                            
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                </div>
               :
                    <div className="table-container">
                            <div className="title">未有預約比賽 &nbsp;&nbsp;
                                <img src={ mark }
                                    alt="Poker Tournament Association"
                                    className="icon"
                                />

                            </div>
                    </div>        
               
               
               
               
               }          
            </div> 
        </div>

        <div className="banner-section">
            <img src={ Promote1 }
                alt="Poker Tournament Association"
                className="bannerImage1"
            />
        </div> 
    </div>  
    
  )
}

export default MyBooking
